import styled from "styled-components";
import { fontSizeVariants } from "../../globalStyles";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Input = styled.input`
  background-color: var(--grey-primary);
  border-radius: 8px;
  color: ${({ $color }) => $color};
  font-size: ${fontSizeVariants["body1"]};
  padding: 8.5px 16px;
  margin: 0;
  outline: none;
  transition: border-color 0.15s;
  border: 2px solid transparent;
  border-color: ${({ $error }) => ($error ? "var(--error)" : undefined)};

  &:focus {
    border-color: ${({ $error }) =>
      !$error ? "var(--orange-primary)" : "var(--error)"};
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
